import React from 'react';
import Wetter from '../components/Wetter';
import MyOrtMap from '../components/MyOrtMap';
import logo from '../assets/logo.png'; // Pfad ggf. anpassen
import { Link } from 'react-router-dom';
import './home.css'; // gleiche Styles wie bei Home verwenden

function WetterMuerzzuschlag() {
  return (
    <div className="home-container">
     
      <div className="home-diagramm">
        <h1 className='wetter-container'>WETTER</h1>
        <Wetter ort="muerzzuschlag" />
      </div>
    </div>
  );
}

export default WetterMuerzzuschlag;